<script lang="ts">
	import type { SbLandingPage } from '../types';
	import { page } from '$app/state';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<SbLandingPage>['content'];
	}

	let { content }: Props = $props();
</script>

<svelte:head>
	<title>{content.seo?.title || 'Mill: never waste food again'}</title>
	<meta name="description" content={content.seo?.description} />
	<meta
		property="og:title"
		content={content.seo?.og_title || content.seo?.title || page.data.og_metadata.title}
	/>
	<meta
		property="og:description"
		content={content.seo?.og_description ||
			content.seo?.description ||
			page.data.og_metadata.description}
	/>
	<meta property="og:type" content="website" />
	<meta property="og:url" content={page.data.og_metadata.url} />
	<meta property="og:image" content={content.seo?.og_image || page.data.og_metadata.image} />
	<meta
		property="og:image:secure_url"
		content={content.seo?.og_image || page.data.og_metadata.image}
	/>

	{#if content.no_index}
		<meta name="robots" content="noindex" />
	{/if}
</svelte:head>

<div class="bg-white">
	{#each content.header as headerComponent}
		<Blok content={headerComponent} />
	{/each}

	{#each content.body || [] as body}
		<Blok content={body} />
	{/each}
</div>
